/**
 * A page that displays the subscription template and confirms the store's subscription to a campaign
 * @param $scope
 * @constructor
 */
function StoreSubscriptionController($scope, StoresService, PermissionService, $stateParams, ErrorService, $sce, $state) {

    var self = this;

    /**
     * Initialises the component
     */
    self.initialise = function() {
        self.userContext = PermissionService.userContext;

        if (!self.userContext) {
            return;
        }

        $scope.contextName = self.userContext.getCurrentContextName();

        // Check if the user has access to view the Campaigns page
        checkUserAccessToCampaignManagement();

        self.subscriptionId = $stateParams.id;

        $scope.isLoading = false;
        $scope.acceptedTsCs = false;
        $scope.showValidation = false;

        self.loadSubscription();
    };

    /**
     * Load the subscription
     */
    self.loadSubscription = function () {
        StoresService.getSubscriptionById(self.subscriptionId).then(
            function (result) {
                $scope.subscription = result;
                $scope.TemplateHTML = $sce.trustAsHtml($scope.subscription.TemplateHTML);
            },
            function error (result) {
                ErrorService.showError("An unexpected error has occurred", result);
            }
        )
    };

    /**
     * Check if the user has access to view the Users page
     */
    var checkUserAccessToCampaignManagement = function () {
        if (!PermissionService.doesUserHavePermissionForContext('ManageCampaigns', self.userContext)) {
            PermissionService.navigateToAccessDenied();
        }
    };

    /**
     * Subscribe the current store to the loaded subscription
     */
    $scope.submitSubscription = function () {
        if (!$scope.acceptedTsCs) {
            $scope.showValidation = true;
            return;
        }

        $scope.isLoading = true;

        StoresService.subscribeStore($scope.subscription.Id, self.userContext.StoreId).then(
            function (result) {
                $scope.isLoading = false;
                $state.go('app.storecampaigns', {storeId: self.userContext.StoreId} );
            }
        );
    };

    /**
     * Navigates the user Home
     */
    $scope.cancel = function () {
        $state.go('app.home', {storeId: self.userContext.StoreId } );
    };

    self.initialise();
}

angular
    .module('dashboard')
    .component('storeSubscription',
        {
            templateUrl: 'components/store/subscriptions/storesubscription.2105965e.html',
            bindings: {},
            controller: ['$scope', 'StoresService', 'PermissionService', '$stateParams', 'ErrorService', '$sce', '$state', StoreSubscriptionController]
        });
